import * as React from 'react';
import autobind from 'autobind-decorator';

// Components
import CourseContent from '../Components/CourseContent';
import Navbar from 'Screens/Layout/Common/Components/Navbar';

interface IProps {
    match: any;
}

interface IState {
    pageRef: any;
    course: any;
    pages: any;
}

export default class CourseBodyStudentPage extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
        let pageRef = this.props.match.params.pageRef;
        if (!pageRef) {
            pageRef = 'content';
        }
        this.state = {
            course: null,
            pages: [],
            pageRef: pageRef
        };
    }

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate() {
        let sideListNode = document.getElementById('sideList');
        let selectedLinkNodes = sideListNode.querySelectorAll('li.selectedLink');
        if (selectedLinkNodes) {
            Array.prototype.forEach.call(selectedLinkNodes, node => {
                node.classList.remove('selectedLink');
            });
        }

        sideListNode = document.getElementById(`sideList-${this.state.pageRef}`);
        if (sideListNode) {
            sideListNode.classList.add('selectedLink');
        }
    }

    @autobind
    loadData() {
        let url = `/courseware/api/course/${this.props.match.params.courseId}/data/?format=json`;
        fetch(url)
            .then(response => response.json())
            .then(response => {
                this.setState({
                    course: response['course'],
                    pages: response['pages']
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    handleClick(pageRef) {
        window.history.pushState('', '', `/frontend/courseware/course/${this.props.match.params.courseId}/${pageRef}/`);
        let sideListNode = document.getElementById('sideList');
        let selectedLinkNodes = sideListNode.querySelectorAll('li.selectedLink');
        if (selectedLinkNodes) {
            Array.prototype.forEach.call(selectedLinkNodes, node => {
                node.classList.remove('selectedLink');
            });
        }
        sideListNode = document.getElementById(`sideList-${pageRef}`);
        if (sideListNode) {
            sideListNode.classList.add('selectedLink');
        }
        this.setState({ pageRef: pageRef });
    }


    public render() {
        if (!this.state.course) {
            return <div>Loading...</div>;
        }

        let pages = this.state.pages.map(page => (
            <li
                id={`sideList-${page.id}`}
                key={`p_${page.id}`}
                onClick={() => this.handleClick(page.id)}
                className='page'>
                {page.title}
            </li>
        ));

        return (
            <React.Fragment>
                <Navbar navbarClass='navbar-light' />
                <div className="courseHeader">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-8 courseHeaderTitle">{this.state.course.title}</div>
                        </div>
                    </div>
                </div>
                <div id='courseBody' className='d-flex flex-row container'>
                    <div className='col-xl-3 sideListContainer'>
                        <ul id='sideList' role='menu' aria-labelledby='dLabel'>
                            <li className="level-1">Course Content</li>
                            <li className="level-2" onClick={() => this.handleClick('content')} id='sideList-content'>Multimedia Book</li>
                            <li className="level-2" onClick={() => this.handleClick('content')} id='sideList-content'>Assignments</li>
                            <li className="level-3" onClick={() => this.handleClick('content')} id='sideList-content'>Programming</li>
                            <li className="level-3" onClick={() => this.handleClick('content')} id='sideList-content'>Other Labs</li>
                            <li className="level-2" onClick={() => this.handleClick('content')} id='sideList-content'>About Course</li>
                            <hr />
                            <li className="level-1">Interactions</li>
                            <li className="level-2" onClick={() => this.handleClick('schedule')} id='sideList-schedule'>Schedule</li>
                            <li className="level-2" onClick={() => this.handleClick('discussion-forum')} id='sideList-discussion-forum'>Discussion Forum</li>
                            <li className="level-2" onClick={() => this.handleClick('email')} id='sideList-email'>Email + Archive</li>
                            <hr />
                            <li className="level-1">Performance</li>
                            <li className="level-2" onClick={() => this.handleClick('exams')} id='sideList-progress'>In/out video quizzes</li>
                            <li className="level-2" onClick={() => this.handleClick('marks')} id='sideList-progress'>Grades</li>
                            <li className="level-2" onClick={() => this.handleClick('progress')} id='sideList-progress'>Leaderboard</li>
                            <hr />
                            <li className="level-1">Additional Pages</li>
                            {pages}

                        </ul>
                    </div>
                    <div id='course-content-div' className='col-xl-9'>
                        <CourseContent
                            id={this.state.pageRef}
                            courseid={this.props.match.params.courseId}
                            forumid={null}
                            groupid={null} />
                    </div>
                </div>
            </React.Fragment>
        );
    }
};
